module.exports = __webpack_public_path__ + "img/PR3.c40d16e2.png";